import React from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import forOwn from "mout/object/forOwn";
import has from "mout/object/has";
import values from "mout/object/values";
import sortByPropText from "../../helpers/content/manageSets/sortByPropText";
import countAnsweredQuestions from "../../helpers/assessment/countAnsweredQuestions";
import { PrintLink } from "./";

/* AssessDashTestSummary

Top:
  <AssessDashStartOrResume
    subtest={props.subtest}
    resume={props.resume}
    userAssessmentId={props.userAssessmentId}
    groupUAId={props.groupUAId}
    sub={props.sub}
    topComplete={props.topComplete}
    isStudent={props.isStudent}
    groupUA={props.groupUA}
    userAssessment={props.userAssessment}
  />

  <AssessDashStartOrResume
    subtest={props.subtest}
    resume={props.resume}
    userAssessmentId={props.userAssessmentId}
    groupUAId={props.groupUAId}
    sub={props.sub}
    topComplete={props.topComplete}
    isStudent={props.isStudent}
  />
*/

// displays status information on tests and subtests
export default function AssessDashStartOrResume(props) {
  // function getTestName() {
  //   let testName = ''
  //   if (props.isStudent) {
  //     testName = props.userAssessment && props.userAssessment.assessmentSet ? props.userAssessment.assessmentSet.name : ''
  //   } else {
  //     testName = props.groupUA && props.groupUA.assessmentSet ? props.groupUA.assessmentSet.name : ''
  //   }
  //   return testName
  // }

  // If it's a student we are looking at...


  if (props.userAssessmentId && props.userAssessment) {

    let SubtestList = () => null;
    let subtestListItems = [];
    const scoring = props.userAssessment.scoring;
    const destructured = props.userAssessment.destructuredSubtests;
    // and if the role is student, create links for the main status component
    if (has(props, "userAssessment.assessmentSubtests") && props.isStudent) {
      const sortedSubtests = sortByPropText(
        values(props.userAssessment.assessmentSubtests),
        "index"
      );
      sortedSubtests.forEach(subtest => {
        // If this subtest is complete, it's a Review link
        if (scoring.bySubtest[subtest.setId].complete) {
          subtestListItems.push(
            <li className="completed" key={`sli${subtest.displayName}`}>
              {" "}
              <i className="icon" />
              <Link
                to={`/assessment/testing/${props.userAssessmentId}/${
                  subtest.setId
                }?item=overview`}
              >
                {`Review ${subtest.displayName} Test`}
              </Link>
            </li>
          );
          // if there is time remaining, it's a Continue link
        } else if (destructured[subtest.setId].timeRemaining && props.previousTest  && !props.licenseExpired) {
          subtestListItems.push(
            <li className="in-progress" key={`sli${subtest.displayName}`}>
              {" "}
              <i className="icon" />
              <Link
                to={`/assessment/testing/${props.userAssessmentId}/${
                  subtest.setId
                }`}
              >
                {`Resume ${subtest.displayName} Test`}
              </Link>
            </li>
          );
          // Otherwise, the student hasn't started this subtest so it's a Start link
        } else if(props.previousTest && !props.licenseExpired) {
          subtestListItems.push(
            <li className="not-started" key={`sli${subtest.displayName}`}>
              {" "}
              <i className="icon" />
              <Link
                to={`/assessment/testing/${props.userAssessmentId}/${
                  subtest.setId
                }`}
              >
                {`Start ${subtest.displayName} Test`}
              </Link>
            </li>
          );
        }
      });
    }
    // if there are any subtestListItems, add them to the SubtestList component
    if (subtestListItems.length > 0) {
      SubtestList = () => (
        <ul className="test-progress-links">{subtestListItems}</ul>
      );
    }

    // if the overall test is complete, and this component is used for the top card
    if (props.topComplete) {
      let text;
      // use one of these two messages, depending on role
      props.isStudent
        ? (text = `This assessment is complete. Click a subject to review your answers and view a report.`)
        : (text = `Click below to review your students' answers and performance by subject.`);
      // and return this status
      return (
        <div>
          <p>{text}</p>
          {props.printPath ? <PrintLink  {...props}/> : null}
        </div>
      );
      // but if the test is being resumed
    } else if (props.resume || props.topResume) {
      let text;
      if (props.isStudent) {
        // determine the time remaining and the number of questions to answer
        // and display this in the message.
        let timeRemaining = props.subtest.timeLimit;
        const subtestId = props.subtest.setId;
        if (has(destructured, `${subtestId}.timeRemaining`)) {
          if (destructured[subtestId].timeRemaining) {
            timeRemaining = Math.ceil(
              destructured[subtestId].timeRemaining / 60000
            );
          }
        }
        let questionsAnswered = 0;
        if (props.userAssessment.answersByItem) {
          questionsAnswered = countAnsweredQuestions(
            props.userAssessment.answersByItem[subtestId]
          );
        }
        let totalQuestions = 0;
        if (destructured[subtestId] && destructured[subtestId].items) {
          totalQuestions = destructured[subtestId].items.length;
        }
        text = `${timeRemaining} minute${timeRemaining == 1 ? "" : "s"}
                left to complete ${totalQuestions}
                question${totalQuestions == 1 ? "" : "s"} in
                the ${props.subtest.displayName} test.`;

        text = `You have started the ${props.subtest.displayName} test but not completed it.`
        // simpler message if an educator viewing a student who needs to resume their test or subtest.
      } else if(props.selectedStudent!==""){
       let is_print = false;
       if(props.userAssessment !== null && props.userAssessment.scoring && props.userAssessment.scoring.bySubtest){
       Object.keys(props.userAssessment.scoring.bySubtest).map(function(value) {
        let is_complete = props.userAssessment.scoring.bySubtest[value].complete;
        if (is_complete === true) {
          is_print = true;
        }
      });
      text = `Click below to review your students' answers and performance by subject.`;
      if(is_print===true)
      {
        return (
          <div>
            <p>{text}</p>
            {props.printPath ? <PrintLink  {...props}/> : null}
          </div>
        );
      }
    }
      }else {
        text = `This student has started this ${
          props.sub ? "sub-" : ""
        }test but not completed it.`;
      }
      // return this resume status. If this is used in a subcard, don't
      // display list of subtest links.
     

      return (
        <div>
          {props.sub ? null : <h6>STATUS</h6>}
          <p>{text}</p>
          {props.sub ? null : <SubtestList />}
          {props.isStudent && props.previousTest ? (
            <div className="resume-test-button-container">               
              {props.sub && props.licenseExpired 
                ? <Button disabled={props.licenseExpired} className="expired-test-button" color="primary">
                    License Expired
                  </Button> 
                : <Link
                    to={`/assessment/testing/${props.userAssessmentId}/${
                      props.subtest.setId
                    }`}
                  >
                    <Button className="resume-test-button" color="primary">
                      Resume Test
                    </Button> 
                  </Link>
              }
              {props.printPath ? (
                <PrintLink  {...props}/>
              ) : null}
            </div>
          ) : null}
        </div>
      );
      // Otherwise, the student hasn't started the test or subtest.
      // Reflect that in the status message.
    } else {
      let text;
      if (props.isStudent) {
        if (!props.sub) {
          text = (
            <p>{`You have not started this ${
              props.sub ? "sub-" : ""
            }test. Begin by taking one of the following subject tests:`}</p>
          );
        } else {
          const totalQuestions = destructured[props.subtest.setId].items.length;
          text = (
            <p>{`You will have ${
              props.subtest.timeLimit
            } minutes to complete ${totalQuestions} questions.`}</p>
          );
        }
      } else {
        text = (
          <p>{`This student has not started this ${
            props.sub ? "sub-" : ""
          }test.`}</p>
        );
      }

      // Return a status that reflects not having started. Don't give subtest link list
      // unless this is being displayed in the top card.
      return (
        <div>
          {/* <span>{getTestName()}</span> */}
          {props.sub ? null : <h6>STATUS</h6>}
          {text}
          {props.sub ? null : <SubtestList />}
          {props.isStudent && props.previousTest ? (
            <div className="start-test-button-container">
              {props.licenseExpired 
                ? <Button disabled={props.licenseExpired} className="expired-test-button" color="primary">
                    License Expired
                  </Button> 
                : <Link
                    to={`/assessment/testing/${props.userAssessmentId}/${
                      props.subtest.setId
                    }`}
                  >
                    <Button  className="start-test-button" color="primary">
                      Start Test
                    </Button> 
                  </Link>
              }
              {props.printPath 
                ? <PrintLink  {...props}/>
                : null
              }
            </div>
          ) : null}
        </div>
      );
    }
    // If this is about a group, rather than an individual student, then we return this status.
    // Status isn't used on group subtest cards, so we know we need to provide the status only
    // for the top card.
  } else if (props.groupUAId || props.groupUAIdCompare) {
    return (
      <div>
        {/* <span>{getTestName()}</span> */}
        <p>
          Click the filter bar above to view information on groups of students
          or an individual student. Click the reports below to view detailed
          information on each subject.
        </p>
        {props.printPath ? <PrintLink  {...props}/> : null}
      </div>
    );
    // If we don't have group information or student information, we return an empty status.
  } else {
    return (
      <div>
        <p />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Assessment/AssessDashStartOrResume.js